import { Container, Title, Anchor, Text } from '@mantine/core'
import { Link, usePage } from '@inertiajs/react'
import Seo from '../_Seo'
import { useLocalePath } from '../_localePath'
import { useI18n } from '../_i18n'

// Shared shell for the science guide pages. Title/description/backLabel come from
// the localized guide-content module (via guides/show), passed in here; children
// are the rendered prose. Emits Article JSON-LD so the page is eligible for rich
// results.
export default function GuidePage({
  title,
  description,
  backLabel = 'Back to all guides',
  children,
}) {
  const { canonical_url: url = '' } = usePage().props
  const localePath = useLocalePath()
  const { t } = useI18n()
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    ...(url ? { url, mainEntityOfPage: url } : {}),
    isPartOf: { '@type': 'WebSite', name: t('app_name') },
  }

  return (
    <>
      <Seo title={title} description={description} type="article" jsonLd={jsonLd} />
      <Container size="sm" py="xl">
        <Anchor component={Link} href={localePath('/guides')} size="sm">
          {backLabel}
        </Anchor>
        <Title order={1} mt="md" mb="xs">
          {title}
        </Title>
        <Text c="dimmed" mb="lg">
          {description}
        </Text>
        {children}
      </Container>
    </>
  )
}
